<script>
export default {
    data() {
        return {
            activeTab: true,
            activeModal: false,
            activeHover: true,
            activeLink: false,
            activeDropdown: "",
            yearItems: ['Latest', '2019', '2018','2017', '2016'],
            yearTitle: "Latest",
            companyItems: ['All Companies', 'CHC', 'CDC','CEC', 'HDEC'],
            companyTitle: "All Companies"
        };
    },
    methods: {
        onDropdownToggle(name) {
            this.activeDropdown = this.activeDropdown === name ? "" : name;
        },
        onClickOutside(e) {
            this.activeDropdown = "";
        },
        companyFilter(title) {
            this.companyTitle = title;
        },
        yearFilter(title) {
            this.yearTitle = title;
        }
    }
};
</script>